import React from 'react';
import { CheckCircle, X } from 'lucide-react';

const ThankYouModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full">
        {/* Logo and Success Icon */}
        <div className="bg-gradient-to-r from-green-600 to-teal-600 text-white p-8 rounded-t-2xl text-center">
          <div className="bg-white rounded-lg p-3 inline-block mb-4 shadow-lg">
            <div className="flex flex-col items-center">
              <span className="text-3xl font-black bg-gradient-to-r from-green-600 to-teal-600 bg-clip-text text-transparent">NETIX</span>
              <span className="text-sm font-semibold text-green-600 -mt-1">FIBERNET</span>
            </div>
          </div>
          <CheckCircle className="w-20 h-20 mx-auto text-white mb-4" />
          <h2 className="text-3xl font-bold">Thank You!</h2>
        </div>

        {/* Message */}
        <div className="p-8 text-center">
          <p className="text-lg text-gray-700 mb-4">
            Your payment has been submitted successfully.
          </p>
          <p className="text-sm text-gray-600 mb-6">
            We have received your payment details and will process it shortly. You will receive a confirmation email once the payment is verified.
          </p>
          
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 text-left">
            <p className="text-sm text-blue-900 font-semibold mb-2">What's Next?</p>
            <ul className="text-sm text-blue-800 space-y-1 list-disc list-inside">
              <li>Your payment will be verified within 24 hours</li>
              <li>You'll receive a confirmation email</li>
              <li>Your account will be updated accordingly</li>
            </ul>
          </div>

          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6 text-left">
            <p className="text-xs text-gray-600">
              <span className="font-semibold">Need Help?</span><br />
              Contact us at <span className="text-blue-600 font-semibold">accounts@netixfibernet.com</span>, call <span className="text-blue-600 font-semibold" data-testid="thank-you-mobile-phone">+91 93199 19988</span>, or Office Phone <span className="text-blue-600 font-semibold" data-testid="thank-you-office-phone">06276 - 459015</span>
            </p>
          </div>

          {/* Close Button */}
          <button
            onClick={onClose}
            className="w-full px-6 py-3 bg-gradient-to-r from-green-600 to-teal-600 text-white rounded-lg hover:from-green-700 hover:to-teal-700 transition font-semibold shadow-lg"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThankYouModal;
